import ReactDOM from 'react-dom'
import { StrictMode } from 'react'
import { Root } from 'root'

ReactDOM.render(
  <StrictMode>
    <Root />
  </StrictMode>,
  document.getElementById('root'),
)
